import React, { useState, useEffect } from "react";
import { Link, useNavigate } from 'react-router-dom'
import Logo from "../common/Logo";
import userService from "../../services/userService";
import { useAuth } from "../../contexts/AuthContext";
import loginBg1200Webp from "../../assets/login-bg-1200.webp";
import loginBg480Webp from "../../assets/login-bg-480.webp";
import loginBg1200Jpg from "../../assets/login-bg-1200.jpg";
import loginBg480Jpg from "../../assets/login-bg-480.jpg";

const SignIn = () => {
  const { signin } = userService();
  const navigate = useNavigate();
  const { login } = useAuth();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    const savedUsername = localStorage.getItem("username");
    if (savedUsername) {
      setUsername(savedUsername);
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!username || !password) {
      setError("User Name or Email and password are required");
    } else {
      setError("");
      try {
        const credentials = {
          username, 
          password
        };
        const response = await signin(credentials);        
        login(response.data);
        localStorage.setItem("username", username);
        navigate("/home");
      } catch (error) {
        setError(error.message);
      }
    }
  };

  return (
    <section className="min-h-screen flex items-center bg-gray-50 py-8">
      <div className="container mx-auto">
        <div className="flex justify-center mb-10"> <Logo /></div>

        <div className="bg-white rounded-lg shadow-md overflow-hidden">
          <div className="flex flex-col lg:flex-row">
            {/* visual / banner - responsive picture element */}
            <div className="w-full lg:w-1/2">
              <picture>
                <source
                  type="image/webp"
                  srcSet={`${loginBg480Webp} 480w, ${loginBg1200Webp} 1200w`}
                  sizes="(max-width: 640px) 480px, 1200px"
                />
                <source
                  type="image/jpeg"
                  srcSet={`${loginBg480Jpg} 480w, ${loginBg1200Jpg} 1200w`}
                  sizes="(max-width: 640px) 480px, 1200px"
                />
                <img
                  src={loginBg1200Jpg}
                  alt="Login banner"
                  loading="lazy"
                  className="w-full h-40 sm:h-64 lg:h-full object-cover"
                />
              </picture>
            </div>

            {/* form column */}
            <div className="w-full lg:w-1/2 p-6 sm:p-10 md:p-12">
              <h2 className="mb-6 text-2xl sm:text-3xl font-bold text-dark">Sign In</h2>
              <form onSubmit={handleSubmit} className="space-y-4">
                <InputBox
                  id="signin-username"
                  labelTitle="User Name / Email Address"
                  type="text"
                  name="username"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  autoComplete="username"
                />
                <InputBox
                  id="signin-password"
                  labelTitle="Password"
                  type="password"
                  name="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  autoComplete="current-password"
                />

                {error && <div className="text-red-500 text-sm">{error}</div>}

                <div className="flex justify-end">
                  <Link to={"/ForgetPassword"} className="text-sm text-blue-600 hover:text-primary hover:underline">
                    Forget Password?
                  </Link>
                </div>

                <div>
                  <button
                    type="submit"
                    aria-disabled={!username || !password}
                    className={`w-full rounded-md px-4 py-3 text-white font-medium ${(!username || !password) ? "bg-gray-400 cursor-not-allowed" : "bg-blue-500 hover:bg-blue-600"}`}
                    disabled={!username || !password}
                  >
                    Sign In
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SignIn;

const InputBox = ({ id, type, name, labelTitle, value, onChange, autoComplete }) => {
  return (
    <div className="mt-4">
      <label htmlFor={id} className="mb-2 block text-sm font-medium text-dark">
        {labelTitle}
      </label>
      <input
        id={id}
        type={type}
        name={name}
        value={value}
        onChange={onChange}
        autoComplete={autoComplete}
        className="w-full rounded-md border border-[#E9EDF4] bg-transparent px-4 py-3 text-sm outline-none focus:border-primary focus-visible:shadow-none"
        required
        aria-required="true"
      />
    </div>
  );
};
